<script>
import BuyNow from './buy-now.vue';
import Edit from './edit.vue';
import EditDelta from './edit-delta.vue';
import Add from './add.vue';
import planPropsMixin from '@/plans/mx/plan-props';

export default {
  mixins: [planPropsMixin],
  render() {
    const context = {...{ props: { ...this.$attrs, ...this.$props }, on: { ...this.$listeners }}};

    if (this.$context.is.add2cart) return <Add {...context} />;
    if (this.$context.is.edit) {
      if (this.$context.is.addQty) return <EditDelta {...context} />;
      return <Edit {...context} />;
    }
    return <BuyNow {...context} />;
  },
};
</script>
